import { Playground } from 'docz';
import { Heading } from "../../../../src/components/Heading";
import * as React from 'react';
export default {
  Playground,
  Heading,
  React
};